import Model from 'flarum/common/Model';
export default function extendTagModel() {
  if (typeof flarum === 'undefined' || !flarum?.reg?.onLoad) return;

  // Defer until flarum-tags' Tag model is registered. `onLoad` runs the
  // handler immediately if Tag is already in the registry, otherwise it
  // queues until `flarum.reg.add('flarum-tags', 'common/models/Tag', X)`
  // fires.
  flarum.reg.onLoad('flarum-tags', 'common/models/Tag', Tag => {
    if (!Tag || !Tag.prototype) return;
    Object.assign(Tag.prototype, {
      isClassifieds: Model.attribute('isClassifieds')
    });
  });
}
flarum.reg.add('ramon-classifieds', 'common/extendTagModel', extendTagModel);